import React, { useEffect, useState } from "react";
import { useAppSelector } from "../app/hooks";

const ConnectCams: React.FC = () => {
    
    const { mobileNumber, sessionId, uuid, userId, deviceId } = useAppSelector((state) => state.auth);
    const { linkedAccounts } = useAppSelector((state) => state.account);
    const { selectedFip } = useAppSelector((state) => state.fip);
    const handleFinish = () => {
        const payload = {
           "consentExpiry": "2027-06-29",
           "consentStart": "2026-06-29",
           "I_MOBILE_DEVICEID": deviceId, 
           "FIPDetailsList": Array.from(new Map(linkedAccounts.map((acc: any) => [acc.FIPACCREFNUM, acc])).values()).map((acc: any) => ({
                 "FITYPE": acc.FI_TYPE || "DEPOSIT",
                 "FIPACCLINKREF": acc.FIPACCLINKREF,
                 "FIPACCNUM": acc.MASKED_ACC_NO,
                 "FIPACCREFNUM": acc.FIPACCREFNUM,
                 "FIPACCTYPE": acc.ACC_TYPE,
                 "FIPID": acc.FIPID || selectedFip?.FIP_ID,
                 "FIPName": acc.FIPNAME || selectedFip?.FIP_NAME,
                 "FIPTYPE": "DEPOSIT",
                 "Id": acc.FIPID || selectedFip?.FIP_ID,
                 "LINKEDDATE": acc.LINKEDDATE || new Date().toISOString(),
                 "logo": selectedFip?.LOGO_URL || ""
           })),
           "Frequency": {
              "unit": "Hour",
              "value": "20"
           },
           "I_FETCHPERIOD": "365",
           "I_FETCH_TYPE": "PERIODIC",
           "I_MOBILENUMBER": mobileNumber, 
           "I_SESSION": sessionId,           
           "UUID": uuid,                   
           "I_USERID": userId || mobileNumber              
        };

        try {
            if (window.AndroidInterface) {
                window.AndroidInterface.onConsentEvent("success", JSON.stringify(payload));
                console.log("Fired onConsentEvent(success) to AndroidInterface");
            } else {
                console.warn("AndroidInterface is not available. Mocking onConsentEvent:", payload);
            }
        } catch (e) {
            console.error("Error posting to AndroidInterface:", e);
        }
    };

    const [isSent, setIsSent] = useState(false);

    const handleButtonClick = () => {
        handleFinish();
        setIsSent(true);
    };

    useEffect(() => {
        handleFinish();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkedAccounts, mobileNumber, sessionId, uuid, userId, deviceId, selectedFip]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-fin-bg text-white">
            <div className="bg-fin-surface p-6 rounded-full mb-8 border border-fin-primary/20 shadow-2xl shadow-fin-primary/5">
                <svg className="w-12 h-12 text-fin-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <h1 className="text-3xl font-black mb-3 tracking-tight">Linking Complete!</h1>
            <p className="text-fin-slate text-center max-w-sm mb-12 text-[15px] leading-relaxed">
                {isSent ? "Data sent to your app! You can safely close this screen." : "Your accounts have been successfully linked. Waiting for the application to resume..."}
            </p>
            <button
                onClick={handleButtonClick}
                className="bg-fin-primary text-fin-bg px-10 py-4 rounded-xl font-bold hover:bg-fin-400 transition-all shadow-lg shadow-fin-primary/20"
            >
                {isSent ? "Resend to App" : "Finish & Return to App"}
            </button>
        </div>
    );
};

export default ConnectCams;
